import { render } from "./PortletTest2.vue?vue&type=template&id=76b701d3&scoped=true"
import script from "./PortletTest2.vue?vue&type=script&lang=js"
export * from "./PortletTest2.vue?vue&type=script&lang=js"

import "./PortletTest2.vue?vue&type=style&index=0&id=76b701d3&scoped=true&lang=css"
import "./PortletTest2.vue?vue&type=style&index=1&id=76b701d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b701d3"]])

export default __exports__